/* eslint-disable prettier/prettier */
/* eslint-disable import/named */
import '../../../styles/UsersPageV2.scss';
import { Button, Input } from 'reactstrap/lib';
import { DropdownOption } from '../new/typings';
import {
  FirebaseReducer,
  FirestoreReducer,
  ReduxFirestoreQueries,
  firestoreConnect,
  getFirebase,
  isLoaded,
} from 'react-redux-firebase';
import { IUser } from '../../../../../typings';
import { UserPageProps } from '../typings';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createUser, resetUserPassword, toggleUserStatus } from '../../../actions/users';
import { loader, power, refreshCw } from 'react-icons-kit/feather';
import { toast } from 'react-toastify';
import EmptyState from '../empty-state/EmptyState';
import Helmet from 'react-helmet';
import Icon from 'react-icons-kit';
import LoadingPage from '../../loading/LoadingPage';
import React, { useState } from 'react';
import Select, { ValueType } from 'react-select';
import _ from 'lodash';

interface UsersPagePropsV2 extends UserPageProps {
  auth?: FirebaseReducer.AuthState;
}

const UsersPage: React.FC<UsersPagePropsV2> = ({
  createUser,
  toggleUserStatus,
  resetUserPassword,
  users,
  loading: loadingProp,
  partnerOptions,
  auth,
}) => {
  const [email, setEmail] = useState('');
  const [partnerId, setPartnerId] = useState({ value: '', label: '' });
  const [memberId, setMemberId] = useState({ value: 'Partner', label: 'Member' });
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState('');
  const [resetPasswordLoading, setResetPasswordLoading] = useState('');
  const [editPassword, setEditPassword] = useState('');

  const createNewUser = () => {
    if (partnerId.value === '') {
      toast.error('Select Valid Member');
      return;
    }
    setLoading(true);
    createUser(email, partnerId.value, password, (response: any) => {
      if (response?.data?.errorInfo) {
        console.error(JSON.stringify(response?.data?.errorInfo?.message));
        toast.error(JSON.stringify(response?.data?.errorInfo?.message));
        setLoading(false);
        return;
      }
      if (typeof response.data === 'string') {
        toast.success('User created successfully.');
        setEditPassword('');
      }
      setLoading(false);
    });
  };

  const toggleUserStatusFn = (id: string, currentActive: boolean) => {
    const nextActive = !currentActive;
    setStatusLoading(id);
    toggleUserStatus(id, nextActive, (response: any) => {
      if (response?.data?.errorInfo) {
        toast.error(JSON.stringify(response?.data?.errorInfo?.message));
        setStatusLoading('');
        return;
      }
      toast.success(`User is now ${nextActive ? 'active' : 'inactive'}.`);
      setStatusLoading('');
    });
  };

  const resetPasswordUserFn = (id: string) => {
    if (newPassword !== '' && newPassword === confirmNewPassword) {
      setResetPasswordLoading(id);
      resetUserPassword(id, newPassword, (response: any) => {
        if (response?.data?.errorInfo) {
          toast.error(JSON.stringify(response?.data?.errorInfo?.message));
          setResetPasswordLoading('');
          return;
        } else toast.success(`Password reset done successfully. New password is ${newPassword}`);
        setResetPasswordLoading('');
      });
    } else {
      toast.error('Password field is not set correctly for the user selected');
    }
  };

  if (loadingProp) {
    return <LoadingPage />;
  }

  const filteredUsers = _.pickBy(users, (user: IUser) => {
    if (!user?.email) {
      return false;
    }
    if (memberId.value === 'Partner') {
      return Boolean(user?.partnerId);
    }
    return user?.partnerId === memberId.value;
  });

  return (
    <div className="users-page-v2">
      <Helmet>
        <meta charSet="utf-8" />
        <title>AGE | Users</title>
      </Helmet>
      <div className="users-split-v2">
        <section className="users-list-pane-v2">
          <h1>Users</h1>
          <span className="title-underline-v2" />

          <div className="users-table-header-v2">
            <div>Member</div>
            <div>User</div>
            <div>Password Reset</div>
            <div>Active/Inactive</div>
          </div>

          <div className="users-filter-v2">
            <Select
              classNamePrefix="users-filter-select"
              options={partnerOptions}
              value={memberId}
              onChange={(selectedOption: ValueType<DropdownOption>) => {
                setMemberId((selectedOption as any) || { value: 'Partner', label: 'Member' });
              }}
            />
          </div>

          {_.isEmpty(filteredUsers) ? (
            <div className="users-empty-v2">
              <EmptyState message={'No users to show'} />
            </div>
          ) : (
            <div className="users-table-rows-v2">
              {_.map(filteredUsers, (user: IUser, id: string) => {
                const isActive = (user as any)?.active !== false;
                return (
                <div className="users-table-row-v2" key={String(id)}>
                  <div className="member-cell-v2">{user?.partnerId || '----'}</div>
                  <div>{user?.email}</div>
                  <div className="action-cell-v2">
                    {editPassword === id ? (
                      <div className="reset-inline-v2">
                        <Input
                          type="password"
                          value={newPassword}
                          placeholder="New Password"
                          className="password-input"
                          onChange={(event) => setNewPassword(event.target.value)}
                        />
                        <Input
                          type="password"
                          value={confirmNewPassword}
                          placeholder="Confirm Password"
                          className="password-input"
                          onChange={(event) => setConfirmNewPassword(event.target.value)}
                        />
                        <Button onClick={resetPasswordUserFn.bind(this, id)} className="inline-btn-v2">
                          Reset {resetPasswordLoading === id ? <Icon icon={loader} size={14} className="spin" /> : null}
                        </Button>
                        <Button outline onClick={() => setEditPassword('')} className="inline-btn-v2 cancel">
                          Cancel
                        </Button>
                      </div>
                    ) : (
                      <Icon
                        onClick={() => setEditPassword(id)}
                        className="reset-user"
                        icon={refreshCw}
                        size={16}
                      />
                    )}
                  </div>
                  <div className="action-cell-v2">
                    {statusLoading === id ? (
                      <Icon icon={loader} size={16} className="spin user-loader" />
                    ) : (
                      <button
                        className={`status-toggle-v2 ${isActive ? 'on' : 'off'}`}
                        onClick={() => toggleUserStatusFn(id, isActive)}
                        title={`Set user as ${isActive ? 'inactive' : 'active'}`}
                      >
                        <span className="status-toggle-label-v2">{isActive ? 'ON' : 'OFF'}</span>
                      </button>
                    )}
                  </div>
                </div>
                );
              })}
            </div>
          )}
        </section>

        <section className="users-create-pane-v2">
          <div className="users-user-strip-v2">
            <div className="users-user-label-v2">Hi, {auth?.displayName || auth?.email}</div>
            <button className="users-user-logout-v2" type="button" title="Logout" onClick={() => getFirebase().logout()}>
              <Icon icon={power} size={18} />
            </button>
          </div>

          <h1>Create New User</h1>
          <span className="title-underline-v2" />

          <div className="create-user-form-v2">
            <label>Email<span>*</span></label>
            <Input
              value={email}
              placeholder=""
              className="user-input"
              onChange={(event) => setEmail(event.target.value)}
            />

            <label>Member<span>*</span></label>
            <Select
              classNamePrefix="users-create-select"
              options={partnerOptions}
              value={partnerId}
              onChange={(selectedOption: ValueType<DropdownOption>) => {
                setPartnerId((selectedOption as any) || { value: '', label: '' });
              }}
            />

            <label>Password</label>
            <Input
              type="password"
              value={password}
              placeholder=""
              className="user-input"
              onChange={(event) => setPassword(event.target.value)}
            />

            <Button onClick={createNewUser} className="user-btn-v2">
              Add {loading ? <Icon icon={loader} size={18} className="spin" /> : null}
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
};

const mapQueryToProps = (): ReduxFirestoreQueries => {
  return [
    {
      collection: 'users',
      storeAs: 'users',
    },
    {
      collection: 'partners',
      storeAs: 'partners',
    },
  ];
};

const mapStateToProps = (state: any) => {
  const {
    firestore,
    firebase: { auth },
  }: {
    firestore: FirestoreReducer.Reducer;
    firebase: FirebaseReducer.Reducer;
  } = state;
  const users = firestore.data.users;
  const partnersData = firestore.data.partners;
  const partnerOptions: Array<{ value: string; label: string }> = [];
  _.map(partnersData, (partner, id) => {
    partnerOptions.push({ value: id, label: partner.name });
  });
  partnerOptions.push({ value: 'Partner', label: 'Member' });
  const loading = !isLoaded(users);
  return {
    loading,
    users,
    auth: auth as FirebaseReducer.AuthState,
    partnerOptions,
  };
};

export default compose(
  firestoreConnect(mapQueryToProps),
  connect(mapStateToProps, { createUser, toggleUserStatus, resetUserPassword }),
)(UsersPage);
